export default "__VITE_ASSET__Bllpzesk__"